const getBaseUrl = () => {
    if (process.env.NODE_ENV === 'development') {
      return 'https://carol-photos-backend.onrender.com';//'http://localhost:8080'; // Development backend
    } else {
      return 'https://carol-photos-backend.onrender.com'; // Production backend
    }
  };
  
  export default getBaseUrl;